import loadable from "@loadable/component";

export const PersonalisedCoverPage = loadable(
  () => import("./PersonalisedCoverPage"),
  {
    resolveComponent: mod => mod.PersonalisedCoverPage,
  },
);

export * from "./types";
